import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { banUser } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom, gmToolNewPage],
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      dialogShow: false,
      paramsData: {
        uids: '',
        is_abnormal_op: '',
        expire_time: '',
        reason: '',
        op_type: 1,
        server_id: ''
      },
      isForever: false,
      whetherNot: [{
        label: this.$t('yes'),
        value: true
      }, {
        label: this.$t('no'),
        value: false
      }],
      rules: {
        uids: [{
          required: true,
          validator: validateuids,
          trigger: "blur"
        }],
        expire_time: [{
          required: true,
          message: this.$t('pleaseSelectBanTime'),
          trigger: "blur"
        }],
        reason: [{
          required: true,
          message: this.$t('pleaseInputReason'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, type) {
      this.paramsData.is_abnormal_op = type;
      this.paramsData.uids = data.uid || '';

      if (type) {
        this.isForever = data.expire_time == 0 ? true : false;
        this.paramsData.expire_time = data.expire_time ? data.expire_time : "";
      }

      this.dialogShow = true;
      this.paramsData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        id: this.paramsData.id,
        uids: '',
        expire_time: '',
        reason: '',
        op_type: 1,
        server_id: ""
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      if (!this.paramsData.server_id) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.paramsData));
          data.expire_time = data.isForever ? 0 : data.expire_time;
          data.uids = data.uids.indexOf(",") !== -1 ? data.uids.split(",") : [data.uids];
          data.uids = data.uids.map(function (i) {
            return i = Number(i);
          });
          banUser(_objectSpread({}, data)).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change', data.uids);
            }
          }).finally(function () {
            _this2.issubmit = false;
          });
        }
      });
    }
  }
};